import { AppContext } from "../context";
import { useContext } from "react";

export const Alert = () => {
    const { theme } = useContext<any>(AppContext);
    const color = theme.palette.primary.main

    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-alert-circle">
            <circle cx="12" cy="12" r="10">
            </circle>
            <line x1="12" y1="8" x2="12" y2="12">
            </line>
            <line x1="12" y1="16" x2="12.01" y2="16">
            </line>
        </svg>
    )
}